<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Country Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Country</label>
                <input type="text" class="form-control" id="packaging-name" v-model="cty.name">
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../services/api'
import { country } from '../models/country'
import AppLookupField from '../components/AppLookupField.vue'
import AppDatePicker from '../components/AppDatePicker.vue'
import AppNavBar from '../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
        return {
            cty: {...country},
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ctyApi = api('country')
            this.cty = await ctyApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const ctyApi = api('country')
            if(this.$route.query.id !== undefined) {
                await ctyApi.update(this.cty, this.$route.query.id)
            } else {
                await ctyApi.create(this.cty)
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
    }
}
</script>